/**
 * @file scrollToError.ts
 * @path apps/website/src/lib/scrollToError.ts
 * @description
 */

export const scrollToError = (fieldId: string) => {
  const element = document.querySelector(`[data-field-id="${fieldId}"]`);
  if (!element) {
    console.warn(`Could not find element with data-field-id="${fieldId}"`);
    return;
  }
  
  // Scroll with offset for sticky headers
  element.scrollIntoView({ 
    behavior: 'smooth', 
    block: 'center' 
  });
  
  // Add highlight animation
  element.classList.add('validation-error-highlight');
  setTimeout(() => {
    element.classList.remove('validation-error-highlight');
  }, 3000);
};

export const scrollToFirstError = (fieldIds: string[]) => {
  if (fieldIds.length === 0) return;
  scrollToError(fieldIds[0]);
};
